module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-signal"
  }, [_c('div', {
    staticClass: "one-signal__overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "one-signal__modal"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('button', {
    staticClass: "btn btn--gray",
    on: {
      "click": function($event) {
        return _vm.$emit('close-modal')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "content-modal"
  }, [_c('custom-form', {
    attrs: {
      "handle-submit": _vm.handleSubmitNotification
    }
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Message",
      "name": "message",
      "data-vv-value-path": "input",
      "data-vv-name": "message",
      "error-message": "Fill in the message",
      "has-error": _vm.errors.has('message'),
      "required": true
    },
    model: {
      value: (_vm.notification.data.message),
      callback: function($$v) {
        _vm.$set(_vm.notification.data, "message", $$v)
      },
      expression: "notification.data.message"
    }
  }), _vm._v(" "), (_vm.showError) ? _c('div', {
    staticClass: "error_message"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary btn--block",
    attrs: {
      "type": "submit",
      "disabled": _vm.notification.loading
    }
  }, [_vm._v("\n          " + _vm._s(_vm.notification.loading ? 'Sending...' : 'Send notification') + "\n        ")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15dac676"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalOneSignal.vue
// module id = 1623
// module chunks = 2